import DashboardIcon from '@mui/icons-material/Dashboard';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import BarChartIcon from '@mui/icons-material/BarChart';
import HistoryIcon from '@mui/icons-material/History';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

// Officer left navigation exactly per wireframe (Phase 2+ items disabled).
export const officerNav = [
  { label: 'Dashboard', path: '/officer', icon: <DashboardIcon /> },
  { label: 'Create Tender', path: '/officer/tenders/new', icon: <AddBoxIcon /> },
  { label: 'Manage Tenders', path: '/officer/tenders', icon: <ListAltIcon /> },
  { label: 'Bid Opening', path: '/officer/bid-opening', icon: <LockOpenIcon /> },
  { label: 'Evaluation Workspace', path: '/officer/evaluation', icon: <AssessmentIcon /> },
  { label: 'Contract Awards', path: '/officer/award', icon: <EmojiEventsIcon /> },
  { label: 'Reports', path: '/officer/reports', icon: <BarChartIcon /> },
];

// EVALUATOR is only routed to /officer/evaluation (see App.js route roles) -
// every other officerNav link would trip ProtectedRoute and bounce them to
// /portal. Keep their nav limited to what they can actually reach.
export const evaluatorNav = [
  { label: 'Evaluation Workspace', path: '/officer/evaluation', icon: <AssessmentIcon /> },
];

// AUDITOR is routed to /officer/audit and /officer/reports.
export const auditorNav = [
  { label: 'Reports', path: '/officer/reports', icon: <BarChartIcon /> },
  { label: 'Audit Logs', path: '/officer/audit', icon: <HistoryIcon /> },
];

// ADMIN sees the console and the oversight reports (so the sidebar stays
// consistent when an admin moves between /admin and /officer/reports).
export const adminNav = [
  { label: 'Admin Console', path: '/admin', icon: <AdminPanelSettingsIcon /> },
  { label: 'Reports', path: '/officer/reports', icon: <BarChartIcon /> },
  { label: 'Audit Logs', path: '/officer/audit', icon: <HistoryIcon /> },
];

// Resolves the correct left-nav set for whichever role is viewing an
// officer-family page (OfficerDashboard/ManageTenders/etc. stay officer-only
// today, but EvaluationList, EvaluationWorkspace and AuditLogs are shared
// with EVALUATOR/AUDITOR too).
export function navForRole(role) {
  if (role === 'ADMIN') return adminNav;
  if (role === 'EVALUATOR') return evaluatorNav;
  if (role === 'AUDITOR') return auditorNav;
  return officerNav;
}
